import { Component, OnInit, Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { RegisterAsIndividual } from 'src/app/shared/models/users/register-as-individual';
import { Error } from 'src/app/shared/models/general/error';
import { getEmailRegExpression } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-new-user-modal',
  templateUrl: './new-user-modal.component.html',
  styleUrls: ['./new-user-modal.component.scss'],
})
export class NewUserModalComponent implements OnInit {
  @ViewChild('newUserModal', { static: true }) newUserModal: any;

  @Input() showModal: boolean = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() onModelChange = new EventEmitter<RegisterAsIndividual>();

  busy: boolean = false;
  showError: boolean;
  errorMsg: string = 'Unable to create user, please try again later.';
  idNumberInUse: boolean = false;
  formInvalid: boolean = false;

  regexForEmail = getEmailRegExpression();

  userDetails: RegisterAsIndividual = new RegisterAsIndividual();

  constructor(
    public settingsService: SettingsService,
    public usersService: UserService,
    public activeModal: NgbActiveModal,
    private el: ElementRef
  ) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.showHideModal(null);
    this.idNumberInUse = false;
  }

  ngAfterViewInit() {}

  onClosed(event: any) {
    if (this.showModal != false) {
      this.userDetails = new RegisterAsIndividual();
      this.showModal = false;
      this.showModalChange.emit(this.showModal);
    }
  }

  showHideModal(toggle: boolean) {
    if (toggle != null) {
      this.showModal = toggle;
    }

    if (this.showModal) {
      this.userDetails = new RegisterAsIndividual();
      this.newUserModal.show();
    } else if (!this.showModal) {
      // Blur any focused element before hiding modal to prevent aria-hidden warning
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.userDetails = new RegisterAsIndividual();
      this.newUserModal.hide();
    }

    this.showModalChange.emit(this.showModal);
  }

  //Update user profile
  saveClicked(form: NgForm) {
    // stop here if form is invalid
    this.formInvalid = form.invalid || this.idNumberInUse;
    if (this.formInvalid) {
      form.form.markAllAsTouched();
      this.scrollToFirstInvalidControl();
      return;
    }
    this.busy = true;
    this.userDetails.brokerId = this.settingsService.brokerUsers[0].brokerId;
    this.userDetails.createdByUserId = this.settingsService.user.id;
    this.usersService.RegisterAsIndevidual(this.userDetails).subscribe({
      next: () => {
        this.showError = false;
        this.busy = false;
        this.onModelChange.emit(this.userDetails);
        this.showHideModal(false);
      },
      error: (error) => {
        this.parseAndDisplayError(error);
      },
    });
  }

  CheckIfIdInUse() {
    if (this.shouldCheckIdNumber() === false) {
      return;
    }
    this.usersService.GetIdNumberInUse(this.userDetails.idNumber).subscribe({
      next: (idInUse: boolean) => {
        this.idNumberInUse = idInUse;
      },
      error: (error) => {
        this.parseAndDisplayError(error);
      },
    });
  }

  private shouldCheckIdNumber(): boolean {
    if (this.userDetails.idNumber.length != 13) {
      return false;
    }
    return true;
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector('form .ng-invalid');

    firstInvalidControl.focus(); //without smooth behavior
  }

  parseAndDisplayError(error: any) {
    this.errorMsg = Error.InterpretErrorMessage(error);
    this.showError = true;
    this.busy = false;
  }
}
